module.exports = __webpack_public_path__ + "img/cat-04-in.be95a972.svg";